import { Box, Stack, Typography } from '@mui/material';
import { IPatientInfo } from 'apis/admin/type';

interface Props {
  disabled?: boolean;
  patientInfo: IPatientInfo;
}

const contents = [
  '70세 이상 또는 14세 이하',
  '이뇨제, 진정제, 항경련제 등의 약물을 복용하시는 분',
  '낙상경험, 보행장애, 혼미, 어지러움증이 있으신 분',
  '전신쇠약, 시력 및 청력장애, 배뇨 및 배설장애, 골다공증이 있으신 분',
  '기타 낙상의 위험이 높으신 분',
];

const BloodType = (props: Props) => {
  const {
    disabled,
    patientInfo: { blood },
  } = props;

  return (
    <>
      <Box
        sx={{
          width: '100%',
          margin: '18px auto 48px auto',
          justifyContent: 'right',
          display: 'flex',
          // flexDirection: 'column',
        }}
      >
        <Stack direction="column">
          <div
            style={{
              border: '1px solid black',
              width: '140px',
              height: '56px',
              textAlign: 'center',
              paddingTop: '15px',
              borderRadius: '4px',
            }}
          >
            혈액형(ABO/RH)
          </div>
          <div
            style={{
              border: '1px solid black',
              width: '140px',
              height: '132px',
              textAlign: 'center',
              paddingTop: '30px',
              borderRadius: '4px',
              marginTop: '-1px',
              backgroundColor: '#e4e4e4',
              fontSize: '46px',
            }}
          >
            {blood}
          </div>
        </Stack>
      </Box>
    </>
  );
};

export default BloodType;
